module.exports = __webpack_public_path__ + "static/media/recover-form.890ac543.png";